import roomAvatar from './components/index.vue';

roomAvatar.install = function(Vue) {
  Vue.component(roomAvatar.name, roomAvatar)
}

export default roomAvatar
